// extracted by mini-css-extract-plugin
export var externalLink = "_8q-0";
export var internalLinkLabel = "_8q-1";